var _rect, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgClaimSymbolSocial(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 41,
    height: 33,
    viewBox: "0 0 41 33",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_1683_20229",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 41,
    height: 33
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 41,
    height: 33,
    fill: "#C4C4C4"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_1683_20229)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 9.84,
    cy: 29.6996,
    rx: 28.4267,
    ry: 28.6,
    fill: "#FFB801"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.1612 22.55C11.1612 22.55 9.29346 22.55 9.29346 20.6708C9.29346 18.7917 11.1612 13.1542 20.5001 13.1542C29.839 13.1542 31.7068 18.7917 31.7068 20.6708C31.7068 22.55 29.839 22.55 29.839 22.55H11.1612ZM20.5001 11.275C21.9862 11.275 23.4114 10.6811 24.4623 9.62381C25.5131 8.56658 26.1035 7.13266 26.1035 5.6375C26.1035 4.14234 25.5131 2.70842 24.4623 1.65119C23.4114 0.593949 21.9862 0 20.5001 0C19.014 0 17.5888 0.593949 16.538 1.65119C15.4871 2.70842 14.8968 4.14234 14.8968 5.6375C14.8968 7.13266 15.4871 8.56658 16.538 9.62381C17.5888 10.6811 19.014 11.275 20.5001 11.275Z",
    fill: "#FFE8AC"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClaimSymbolSocial);
export default __webpack_public_path__ + "static/media/claim-symbol-social.3a03e0641f6b377dba7fbb3120a14522.svg";
export { ForwardRef as ReactComponent };